<template>
  <div
    class="project-hero text-light bg-color-base"
    :style="`background-image: url(${content ? content.image : null})`"
  >
    <b-container v-if="content" fluid="md" class="project-hero__content">
      <h1 class="project-hero__content__title display-3 font-weight-bolder">
        {{ content.name }}
      </h1>
      <div class="project-hero__content__subtitle">
        <h5>
          Año de inicio de construcción:
          <span class="font-weight-light">{{ content.age }}</span>
        </h5>
        <h5>
          Ubicación:
          <span class="font-weight-light">{{ content.location }}</span>
        </h5>
      </div>
      <div v-if="projects" class="project-hero__content__navigation">
        <div class="arrow-left noselect" @click="prevProject">
          <img src="@/assets/ico_arrow.svg" alt="Projecto anterior">
        </div>
        <div class="arrow-right noselect" @click="nextProject">
          <img src="@/assets/ico_arrow.svg" alt="Projecto siguiente">
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "ProjectHero",
  props: {
    content: Object,
    projects: Array
  },
  methods: {
    nextProject: function () {
      if (this.projects.length) {
        let element = this.projects.find(
          (project) => project.name == this.content.name
        );
        let index = this.projects.indexOf(element);
        if (typeof index == "number") {
          let nextIndex = index + 1;
          if (nextIndex >= this.projects.length || nextIndex < 0) nextIndex = 0;
          this.$router.push(`/proyecto/${this.projects[nextIndex].id}`);
        }
      }
    },
    prevProject: function () {
      if (this.projects.length) {
        let element = this.projects.find(
          (project) => project.name == this.content.name
        );
        let index = this.projects.indexOf(element);
        if (typeof index == "number") {
          let prevIndex = index - 1;
          if (prevIndex < 0) prevIndex = this.projects.length - 1;
          this.$router.push(`/proyecto/${this.projects[prevIndex].id}`);
        }
      }
    }
  }
};
</script>

<style scoped lang="sass">
.project-hero
  background-repeat: no-repeat
  background-size: cover
  background-position: center center
  text-align: center
  height: calc( 100vh - 94px )
  &__content
    height: 100%
    position: relative
    &__title
      letter-spacing: 5px
      position: absolute
      top: 30%
      left: 50%
      transform: translateX(-50%)
    &__subtitle
      position: absolute
      bottom: 20%
      left: 50%
      transform: translateX(-50%)
    &__navigation
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      width: 100%
      display: flex
      justify-content: space-between
      align-items: center
      .arrow
        &-left, &-right
          padding: 1rem
          background: #EAEDE7
          cursor: pointer
          transition: all 300ms ease
          img
            padding: 0 0 0 0.25rem
          &:hover, &:active
            background: #ACB7A1
            img
              filter: brightness(2)
        &-right img
          transform: rotate(180deg)
  @media screen and (max-width: 768px)
    &__content
      &__title
        font-size: 3.5rem
        top: 10%
        width: 100%
      &__subtitle
        width: 70%
        bottom: 20%
        h5
          font-size: 1rem
  @media screen and (max-width: 502px)
    &__content
      &__title
        font-size: 3rem
        width: 70%
      &__subtitle
        bottom: 10%
</style>
